module.exports = __webpack_public_path__ + "static/media/design-leather.4d741883.svg";